var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h2',[_vm._v("CUSTODIAL CARE OR MAINTENANCE CARE")]),_c('h4',[_vm._v(" Care which is primarily for the purpose of assisting the Member in the activities of daily living or in meeting personal rather than medical needs which is not specific therapy for an illness or injury and is not skilled care. ")])])
}]

export { render, staticRenderFns }